<template>
  <div>
    <div class="box">
      <div class="title">{{ title }}</div>
      <div class="price" >{{ price }} <span style="font-size: 20px;">  {{ unit }}</span> </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    price: {
      type: String,
    },
    unit: {
      type: String,
    },
    isYellow: {// 字体颜色
      type: Boolean,
      default: false
    },
    isBlue: {// 背景色
      type: Boolean,
      default: true
    }

  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.box {
text-align: center;
  // width: 148px;
  height: 144px;
  position: relative;
  display: flex
;
    flex-direction: column;
    justify-content: center;
.title{
font-family: Source Han Sans CN;
font-weight: 500;
font-size: 16px;
color: #000000;

}
}



.price {
font-family: Source Han Sans CN;
font-weight: bold;
font-size: 32px;
color: #FF5050;
}




</style>
